import { SHOWCASE } from "../lib/zoco";

export const Products = () => {
  return (
    <section
      id="productos"
      data-testid="products-section"
      className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto bg-[#F7F1E3]"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 items-end">
        <div className="md:col-span-7">
          <p className="font-sans-z text-[10px] uppercase tracking-[0.32em] font-semibold text-[#034638] mb-5">
            Lo que encontrarás
          </p>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight text-[#034638] leading-[1.0]">
            Especias, frutos secos,<br />
            <span className="italic text-[#0B5A4A]">café y miel.</span>
          </h2>
        </div>
        <div className="md:col-span-5">
          <p className="font-sans-z text-base text-[#1A2823]/80 leading-relaxed">
            Una frutería selecta especializada en lo que da carácter a tu
            cocina: especias, frutos secos, café de especialidad, mieles de
            origen, fruta de temporada y producto artesano.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
        {SHOWCASE.map((s) => (
          <article
            key={s.id}
            data-testid={`showcase-card-${s.id}`}
            className="group flex flex-col"
          >
            <div className="relative overflow-hidden bg-[#EFE8D6] aspect-[4/5]">
              <img
                src={s.image}
                alt={s.title}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                loading="lazy"
              />
              <span className="absolute top-4 left-4 bg-[#F7F1E3]/95 backdrop-blur-sm text-[#034638] font-sans-z text-[9px] uppercase tracking-[0.28em] font-semibold px-3 py-2">
                {s.label}
              </span>
            </div>

            <div className="pt-6">
              <p className="font-sans-z text-[10px] uppercase tracking-[0.28em] font-semibold text-[#034638] mb-2">
                {s.subtitle}
              </p>
              <h3 className="font-display text-2xl md:text-3xl tracking-tight text-[#1A2823] leading-tight mb-3">
                {s.title}
              </h3>
              <p className="font-sans-z text-sm text-[#1A2823]/75 leading-relaxed">
                {s.description}
              </p>
            </div>
          </article>
        ))}
      </div>

      {/* Closing CTA */}
      <div className="mt-20 md:mt-28 border-t border-[#D9CFB6] pt-12 md:pt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <p className="font-sans-z text-[10px] uppercase tracking-[0.32em] font-semibold text-[#034638] mb-4">
            ¿Quieres pedir?
          </p>
          <p className="font-display text-3xl md:text-4xl tracking-tight text-[#034638] leading-tight max-w-2xl">
            Para hacer un pedido, escríbenos por WhatsApp o pásate por la
            tienda. <span className="italic text-[#1A2823]/70">Te atendemos personalmente.</span>
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <a
            href="#contacto"
            data-testid="products-contact-cta"
            className="inline-flex items-center gap-2 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold text-[#034638] border-b-2 border-[#034638] pb-1 hover:border-[#7DB7B0] hover:text-[#0B5A4A] transition-colors"
          >
            Ver cómo contactar
          </a>
        </div>
      </div>
    </section>
  );
};

export default Products;
